module.exports = __webpack_public_path__ + "img/_ABS9796(1).3f98fa67.jpg";